import { useState } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import AddAShopSignUp from '@Components/Shared/AddAShop/AddAShopSignUp';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';

const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

const EcommerceView = (props) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const toggleModal = () => setModalIsOpen(modalIsOpen => !modalIsOpen);

    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='ecommerce-container'>
                <div className='ecommerce'>
                    <h1><TranslationText tKey='Sandhills.TradeSites.MVC.WeMakeECommerceEasy' /></h1>
                    <h2>{translator.translate('Sandhills.TradeSites.MVC.GetYourOwnOnlineStore', [props.PublicationSite])}</h2>
                    <a href={props.AddAShopSignUpURL} tabIndex='0' className='button send-email-link open-modal-btn ts-button' target='_blank' aria-label={translator.translate('Sandhills.TradeSites.MVC.CreateYourStoreToday') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}><TranslationText tKey='Sandhills.TradeSites.MVC.CreateYourStoreToday' /></a>
                    <div dangerouslySetInnerHTML={{ __html: props.CAPrivacyPolicyNotice }} style={{ 'font-size': '.75em' }} />
                    <div className='ecommerce-sample'>
                        <div className='ecommerce-text'>
                            {props.UseSEOHTagReorganization ?
                                <>
                                    <h3>Reinvent An Online Store Today</h3>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.IfYouThinkYouDontHaveTime' />
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillHelpYouGetEverythingSetup' />
                                </>
                                :
                                <>
                                    <h3><TranslationText tKey='Sandhills.TradeSites.MVC.IfYouThinkYouDontHaveTime' /></h3>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillHelpYouGetEverythingSetup' />
                                </>
                            }
                        </div>
                        <img src='/Content/images/Ecommerce/ecommerce-banner.png' alt=""/>
                    </div>
                    {!props.UseSEOHTagReorganization ?
                        <div className='ecommerce-facts cf'>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/build.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WellBuildItForYou' />
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillCreateYourOnlineStore' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/rates.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                        <strong><TranslationText tKey='Sandhills.TradeSites.MVC.BenefitFromLowRates' /></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeOfferHighlyCompetitiveRates' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/merchant.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><TranslationText tKey='Sandhills.TradeSites.MVC.BeYourOwnMerchant' /></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillHelpYouGetStartedWithCurrencyPay' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/control.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><TranslationText tKey='Sandhills.TradeSites.MVC.EnjoyTotalControl' /></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.YouCanUseTheInventoryManagementSystem' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/buy.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                        <strong><TranslationText tKey='Sandhills.TradeSites.MVC.WellSpreadTheWord' /></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.ABuyNowButtonWillAppear' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/fast.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><TranslationText tKey='Sandhills.TradeSites.MVC.ItsFastAndEasy' /></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.ClickBelowOrContactYourRepToGetStarted' />
                                </div>
                            </div>
                        </div>
                        :
                        <div className='ecommerce-facts cf'>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/build.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='sandhills.tradesites.mvc.wellbuildanonlinestore' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillCreateYourOnlineStore' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/rates.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='Sandhills.TradeSites.MVC.BenefitFromLowRates' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeOfferHighlyCompetitiveRates' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/merchant.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='Sandhills.TradeSites.MVC.beyourownmerchantwithcurrencypay' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.WeWillHelpYouGetStartedWithCurrencyPay' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/control.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='Sandhills.TradeSites.MVC.enjoytotalcontrolofinventory' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.YouCanUseTheInventoryManagementSystem' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/buy.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='Sandhills.TradeSites.MVC.WellSpreadTheWord' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.ABuyNowButtonWillAppear' />
                                </div>
                            </div>
                            <div className='ecommerce-factbox'>
                                <img src='/Content/images/Ecommerce/fast.png' alt="" />
                                <div className='ecommerce-factbox-text'>
                                    <strong><h4 className="header-reset"><TranslationText tKey='Sandhills.TradeSites.MVC.startsellingfastandeasy' /></h4></strong>
                                    <TranslationText tKey='Sandhills.TradeSites.MVC.ClickBelowOrContactYourRepToGetStarted' />
                                </div>
                            </div>
                        </div>
                    }
                    <div className='ecommerce-addashop-signup'>
                        <AddAShopSignUp
                            signUpUrl={props.AddAShopSignUpURL}
                            feedbackCallback={toggleModal}
                        />
                        <img src='/Content/images/Ecommerce/sell-banner.png' alt="" />
                    </div>
                </div>
                {modalIsOpen &&
                    <FeedbackModal
                    {...props}
                    toggleModal={toggleModal}
                    title={translator.translate('Sandhills.TradeSites.MVC.CreateAnECommerceStore')}
                    />}
            </div>
        </div>
    );
};

export default EcommerceView;
global.EcommerceView = EcommerceView;